export function equalizeHeights(element) {
  let elements = document.querySelectorAll(element),
    allHeights = [],
    i = 0

  for(i = 0; i < elements.length; i++){
    elements[i].style.height = 'auto'
  }

  for(i = 0; i < elements.length; i++){
    let elementHeight = elements[i].clientHeight
    allHeights.push(elementHeight)
  }

  for(i = 0; i < elements.length; i++){
    elements[i].style.height = Math.max.apply( Math, allHeights) + 'px'
  }
}

function removeStyles(element) {
  const items = document.querySelectorAll(element)

  items.forEach(function (item, index) {
    item.removeAttribute('style')
  })
}

window.addEventListener('load', function () {
  equalizeHeights('.slider__slide .box-slider')
  equalizeHeights('.features .features__item')
  equalizeHeights('.benefit .benefit__image')
  equalizeHeights('body[class*="bc-"] .article .article__content')

  if (window.innerWidth < 960) {
    equalizeHeights('.events .events__item')
  }

  if (window.innerWidth > 600) {
    equalizeHeights('.brands-products .brands__item')
    equalizeHeights('.categories .categories__item')
  }
})

window.addEventListener('resize', function () {
  equalizeHeights('.features .features__item')
  equalizeHeights('.benefit .benefit__image')
  equalizeHeights('body[class*="bc-"] .article .article__content')

  if (window.innerWidth < 960) {
    equalizeHeights('.events .events__item')

  } else {
    removeStyles('.events .events__item')
  }

  if (window.innerWidth < 600) {
    removeStyles('.brands-products .brands__item')
    removeStyles('.categories .categories__item')
  } else {
    equalizeHeights('.brands-products .brands__item')
    equalizeHeights('.categories .categories__item')
  }
})
